import { createSelector } from 'reselect';

export const summaryDrawerSelector = createSelector(
  (state) => state.summaryDrawer,
  (isOpen) => isOpen,
);
